/** @flow */

import type { State } from "@store/reducers";
import type { FocusListsType } from "@modules/reporting/reducer/focus-lists/types";
import type {
  ManagerReport,
  Reports,
  DefaultReports,
} from "@modules/reporting/reducer/focus-lists/manager/types";

export type GetReportsSchema = (state: State) => ?Object;
export type GetReportToSave = (state: State) => ?ManagerReport;

export const getManagerFocusLists = (state: State): $PropertyType<FocusListsType, "manager"> =>
  state.reporting.focusLists.manager;

export const getReports = (state: State): Reports => getManagerFocusLists(state).reports;

export const getDefaultReports = (state: State): DefaultReports =>
  getReports(state).defaultReports || [];

export const getMyReports = (state: State): DefaultReports => getReports(state).myReports || [];

export const getReportsSchema = (state: State): ?Object => getReports(state).schema;

export const getReportToSave = (state: State): ?ManagerReport => getReports(state).reportToSave;

export const isLoading = (state: State): boolean =>
  state.reporting.focusLists.manager.reports.requestsInProgress > 0;
